<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="students">

          <template slot="thead">
            <vs-th sort-key="username">{{ $t("sections.user.dataForm.username") }}</vs-th>
            <vs-th sort-key="nameSurname">{{ $t("sections.user.dataForm.name") +" - "+ $t("sections.user.dataForm.surname") }}</vs-th>
            <vs-th sort-key="email">{{ $t("sections.user.dataForm.email") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.user.dataForm.status") }}</vs-th>
            <vs-th sort-key="role">{{ $t("sections.user.dataForm.role") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.username">
                {{ tr.username }}
              </vs-td>
              <vs-td :data="prefix(tr.prefix)+' '+ tr.name+' '+tr.surname">
                {{ prefix(tr.prefix)+' '+ tr.name+' '+tr.surname }}
              </vs-td>
              <vs-td :data="tr.email">
                {{ tr.email }}
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip :color="getStatusColor(tr.status)" class="product-order-status">{{ tr.status }}</vs-chip>
              </vs-td>
              <vs-td :data="role(tr.role)">
                {{ role(tr.role) }}
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vx-tooltip text="เปิดหน้า Student Web">
                    <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-airplay" @click="showStudentWebMaintenance"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="สร้างรหัสผ่านชั่วคราว สำหรับเข้าสู่ Student App">
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-phone-call" v-if="display(tr) && pms ('UserStudent', 'edit', 'b')" @click="createPasswordDummyStudentAppById(tr.id)"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="รีเซ็ตรหัสผ่าน">
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-refresh-ccw" v-if="display(tr) && pms ('UserStudent', 'edit', 'b')" @click="rePass();actionID=tr.id"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="แก้ไขข้อมูล">
                    <router-link :to="{ name: 'user-student-edit', params: {id: tr.id} }" >
                      <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="display(tr) && pms ('UserStudent', 'edit', 'b')" ></vs-button>
                    </router-link>
                  </vx-tooltip>
                  <vx-tooltip text="ลบข้อมูล">
                    <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="display(tr, 'del') && pms ('UserStudent', 'delete', 'b')" @click="del();actionID=tr.id" ></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers, mapState } from 'vuex'

const {mapActions: mapUserActions, mapState: mapUserFields } = createNamespacedHelpers('User')

export default {
  async created() {
    await this.getStudents()
    this.pms ('UserStudent', 'visible', 'r')
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapUserFields(['students', 'status'])
  },
  methods: {
    ...mapUserActions(['getStudents', 'deleteStudent', 'resetStudentPassword', 'createPasswordDummyStudentApp']),
    showStudentWebMaintenance () {
      this.$vs.dialog({
        color: 'warning',
        title: 'ปิดปรับปรุงชั่วคราว',
        text: 'ระบบเข้าสู่ Student Web ผ่านหน้าผู้ดูแลอยู่ระหว่างปิดปรับปรุงชั่วคราว กรุณาเข้าสู่ Student Web ด้วยบัญชีของนักศึกษาโดยตรง',
        acceptText: 'ตกลง',
        buttonAccept: true
      })
    },
    display(res, action){
      if(action === 'del'){
        return false
      }
      return true
    },
    async del () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDel
      })
    },
    async acceptDel () {
      await this.deleteStudent({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    rePass () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('general.confirmReset'),
        text: this.$t('general.confirmResetMessage'),
        accept: this.acceptRePass
      })
    },
    async acceptRePass () {
      await this.resetStudentPassword({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    async createPasswordDummyStudentAppById (id) {
      const response = await this.createPasswordDummyStudentApp({
        form: {
          id
        },
        vm: this
      })
      if (response) {
        this.$vs.dialog({
          color: response.result ? 'success' : 'danger',
          title: response.result ? 'สร้างรหัสผ่านชั่วคราวสำเร็จ' : 'สร้างรหัสผ่านชั่วคราวไม่สำเร็จ',
          text: this.formatDialogMessage(response.msg),
          acceptText: 'ตกลง',
          buttonAccept: true
        })
      }
    },
    formatDialogMessage (message) {
      return (message || '').replace(/\\n/g, '\n')
    },
    prefix (obj) {
      let prefix = ( obj ? obj.nameTh : "" )
      return prefix
    },
    role (obj) {
      let role = ( obj ? obj.nameTh : "" )
      return role
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>

<style>
.vs-dialog-text {
  white-space: pre-line;
}
</style>
